document.addEventListener('DOMContentLoaded', () => {
  const PHONE_PREFIX = '+91 ';
  const PHONE_MAX_DIGITS = 10;

  // Prefix always contributes the leading "91", so strip one occurrence of it.
  const formatPhone = (value) => {
    const digits = value.replace(/\D/g, '').replace(/^91/, '').slice(0, PHONE_MAX_DIGITS);
    return `${PHONE_PREFIX}${digits}`;
  };

  const phoneInputs = document.querySelectorAll('[data-phone-input]');

  for (const input of phoneInputs) {
    if (input.dataset.phoneValidateInitialized) continue;
    input.dataset.phoneValidateInitialized = 'true';

    if (input.value) input.value = formatPhone(input.value);

    input.addEventListener('input', ({ target }) => {
      const offsetFromEnd = target.value.length - (target.selectionStart ?? target.value.length);
      target.value = formatPhone(target.value);
      const caret = Math.max(PHONE_PREFIX.length, target.value.length - offsetFromEnd);
      target.setSelectionRange(caret, caret);
    });

    input.addEventListener('focus', ({ target }) => {
      if (target.selectionStart < PHONE_PREFIX.length) {
        target.setSelectionRange(target.value.length, target.value.length);
      }
    });

    // Submit nothing rather than a bare prefix when the optional field is untouched.
    input.form?.addEventListener('submit', () => {
      if (input.value.replace(/\D/g, '') === '91') input.value = '';
    });
  }
});
